import { OrgData } from '@rolebase/shared/model/OrgData'

// A freshly created org that hasn't been set up yet: only its root circle, no
// base role, and nobody in the root circle. Used to drive the org-setup step
// (and to suppress other onboarding prompts while it runs).
//
// The last condition is what closes an org set up as "Empty": it keeps a
// single circle and no base role for good, but its creator is seated in the
// root circle — without it the setup would reopen on every visit.
export function isOrgFresh(orgData: OrgData | undefined): boolean {
  if (!orgData || orgData.circles.length !== 1) return false
  if (orgData.roles.some((role) => role.base)) return false
  return orgData.membersOf(orgData.circles[0].id).length === 0
}
